import { ShieldCheck } from "lucide-react";

interface TrustBadgeProps {
  title: string;
  subtitle?: string;
  delay?: number;
}

const TrustBadge = ({ title, subtitle, delay = 0 }: TrustBadgeProps) => {
  return (
    <div
      className="group flex items-center gap-4 p-4 bg-card rounded-xl border border-border/50 shadow-soft hover:shadow-badge hover:border-primary/40 transition-all duration-300 hover:-translate-y-1 animate-fade-in"
      style={{ animationDelay: `${delay}ms` }}
    >
      <div className="relative flex-shrink-0">
        {/* Glow effect */}
        <div className="absolute inset-0 w-12 h-12 rounded-full bg-blue-700/20 blur-md group-hover:bg-blue-500/30 transition-colors duration-300" />
        <div className="relative w-12 h-12 rounded-full gradient-primary flex items-center justify-center shadow-badge">
          <ShieldCheck
            className="w-6 h-6 text-primary-foreground"
            strokeWidth={2.5}
          />
        </div>
      </div>
      <div className="flex flex-col">
        <span className="font-semibold text-foreground text-base md:text-lg leading-tight group-hover:text-primary transition-colors duration-300">
          {title}
        </span>
        {subtitle && (
          <span className="text-muted-foreground text-sm mt-0.5">
            {subtitle}
          </span>
        )}
      </div>
    </div>
  );
};

export default TrustBadge;
